import React from "react";
import { orderingProcess } from "../../data/Data";

const OrderingProcess = () => {
  return (
    <section className="relative w-full overflow-hidden bg-lightPastelPurple px-4 py-10 md:py-12">
      <div className="absolute left-0 top-8 h-56 w-56 rounded-full bg-pastelPurple opacity-55 blur-3xl"></div>
      <div className="absolute bottom-8 right-0 h-56 w-56 rounded-full bg-keyLime/20 blur-3xl"></div>

      <div className="relative mx-auto max-w-7xl">
        {/* SECTION TITLE */}
        <div className="mb-8 text-center">
          <h2 className="text-3xl font-extrabold tracking-tight text-darkPurple md:text-4xl">
            OUR ORDERING PROCESS
          </h2>

          <div className="mx-auto mt-3 flex w-full max-w-[230px] items-center justify-center gap-3">
            <span className="h-[1px] flex-1 bg-[#d8c8ff]"></span>
            <span className="h-2.5 w-2.5 rounded-full bg-keyLime shadow-[0_0_0_5px_rgba(215,255,79,0.25)]"></span>
            <span className="h-[1px] flex-1 bg-[#d8c8ff]"></span>
          </div>
        </div>

        {/* GRID */}
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6">
          {orderingProcess.map((step, index) => (
            <div
              key={step.id}
              className="group relative flex h-full flex-col rounded-[22px] border border-pastelPurple bg-white p-3 text-center shadow-[0_10px_26px_rgba(47,34,84,0.07)] transition-all duration-300 hover:-translate-y-1 hover:border-[#d8c8ff] hover:shadow-[0_18px_42px_rgba(47,34,84,0.13)]"
            >
              {/* IMAGE */}
              <div className="flex h-[165px] items-center justify-center rounded-[18px] bg-gradient-to-br from-[#f2ecff] via-white to-[#f8ffe0] p-4 md:h-[175px]">
                <img
                  src={step.img}
                  alt={step.title}
                  className="max-h-full max-w-full object-contain transition-transform duration-500 group-hover:scale-105"
                />
              </div>

              {/* TITLE */}
              <h3 className="mt-4 min-h-[48px] text-base font-extrabold leading-6 text-darkPurple md:text-lg">
                {step.title}
              </h3>

              {/* DESCRIPTION */}
              <p className="mt-2 text-sm font-medium leading-6 text-[#5f5870]">
                {step.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OrderingProcess;